angular.module("app").controller("ProvidersListPageController", [
    '$scope',
    'preloadedData',
    'pageStatuses',
    'pagination',
    '$timeout',
    'casinoProviderService',
    'errorHandler',
    '$state',
    '$stateParams',
    'settingsService',
    'preloadedProviders',
    '$filter',
    '$uibModal',
    'toolsMap',
    'logger',
    'userStorage',
    function ($scope, preloadedData, pageStatuses, pagination, $timeout, casinoProviderService, errorHandler, $state, $stateParams, settingsService, preloadedProviders, $filter, $modal, toolsMap, logger, userStorage) {
        var pendingListRequest;
        $scope.pageStatuses = pageStatuses;
        $scope.multiSelect = {};
        var providerTitleNameMap = {};
        $scope.multiSelect.providerTitles = angular.copy(preloadedProviders).map(function (item) {
            providerTitleNameMap[item.title] = item.name;
            return item.title;
        });
        $scope.multiSelect.selectedProviders = [];
        $scope.providers = angular.copy(preloadedData.providers);
        $scope.parentId = $stateParams.itemId;
        $scope.filterOptions = {
            status: pageStatuses[0]
        };
        $scope.filterOptions = angular.extend({}, $scope.filterOptions, settingsService.getFilters());
        $scope.pagination = pagination.init(function (resetPage) {
            !!pendingListRequest && $timeout.cancel(pendingListRequest);
            pendingListRequest = $timeout(function () {
                var requestData =  getFiltersValues();
                resetPage === true && (requestData.current_page = 1);
                $scope.parentId && (requestData.parent_id = $scope.parentId);
                updateList(requestData)
            }, 300);
        }, parseInt(preloadedData.total_count), 25);


        $scope.getItemChildes = function (category) {
            $state.go("main.categories.categoryItems", {itemId: category.id}, {reload: false})
        };

        $scope.inactiveToggle = function (page, action, title) {
            var modalInstance = $modal.open({
                templateUrl: "views/templates/modals/confirmToggle" + title + "Action.html",
                controller: "ConfirmDeleteActionModalController"
            });
            modalInstance.result.then(function ()
            {
                casinoProviderService.toggleItemInactive(page.name, title).then(
                    function (response) {
                        if (response.status === "ok") {
                            updateList(getFiltersValues())
                        } else {
                            errorHandler(response.message);
                        }
                    },
                    function (response) {
                        errorHandler(response.message);
                    }
                )

            });
        };

        $scope.deleteProviders = function (item) {
            var modalInstance = $modal.open({
                templateUrl: "views/templates/modals/confirmDeleteAction.html",
                controller: "ConfirmDeleteActionModalController"
            });
            modalInstance.result.then(function () {
                casinoProviderService.deleteCategoryById({id: item.name, status: item.status}).then(
                    function (response) {
                        if (response.status === "ok") {
                            logger.logSuccess("providers has been successfully deleted");
                            updateList(getFiltersValues())
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    }
                )
            })
        };


        $scope.editProvider = function (provider) {
            $modal.open({
                templateUrl: "views/providers/edit.html",
                controller: "ProvidersEditPageController",
                resolve: {
                    preloadedData: function (casinoProviderService, errorHandler) {
                        return casinoProviderService.getProviders({name: provider.name}).then(
                            function (response) {
                                if (response.status === "ok") {
                                    return angular.copy(response);
                                } else {
                                    errorHandler(response.message);
                                    return {}
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                                return {}
                            }
                        )
                    },
                    preloadedParentsList: function (casinoProviderService, errorHandler) {
                        return casinoProviderService.getProviders().then(
                            function (response) {
                                if (response.status == "ok") {
                                    return angular.copy(response);
                                } else {
                                    errorHandler(response.message);
                                    return {}
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                                return {}
                            }
                        )
                    },
                    countryCodes: function(resourcesService) {
                        return resourcesService.getResource("countryCodes.json").then(function (data) {
                            return angular.copy(data);
                        },function (response) {
                            return [];
                        });
                    }
                }
            }).result.then(function () {
                var requestData =  getFiltersValues();
                $scope.parentId && (requestData.parent_id = $scope.parentId);
                updateList(requestData)
            });
            //$state.go($scope.parentId ? "main.providers.editItem" : "main.providers.edit", {providerId: provider.name, itemId: $scope.parentId})
        };

        $scope.addProvider = function () {
            $modal.open({
                templateUrl: "views/providers/add.html",
                controller: "ProvidersAddPageController",
                resolve: {
                    preloadedData: function (casinoProviderService, pageStatuses, errorHandler) {
                        return casinoProviderService.getProviders({status: pageStatuses[0]}).then(
                            function (response) {
                                if (response.status === "ok") {
                                    return angular.copy(response);
                                } else {
                                    errorHandler(response.message);
                                    return {}
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                                return {}
                            }
                        )
                    },
                    countryCodes: function(resourcesService) {
                        return resourcesService.getResource("countryCodes.json").then(function (data) {
                            return angular.copy(data);
                        },function (response) {
                            return [];
                        });
                    }
                }
            }).result.then(function () {
                var requestData =  getFiltersValues();
                $scope.parentId && (requestData.parent_id = $scope.parentId);
                updateList(requestData)
            });
        };
        var iconsCategory = [10] // providers

        $scope.addIcon = function (provider) {
            $modal.open({
                templateUrl: "views/filters/addIcon.html",
                controller: "FiltersAddIconPageController",
                resolve: {
                    preloadedIcons: function (iconsService, errorHandler) {
                        return iconsService.getIconsList(iconsCategory).then(
                            function (response) {
                                if (response.status === "ok") {
                                    return angular.copy(response);
                                } else {
                                    errorHandler(response.message);
                                    return {}
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                                return {}
                            }
                        )
                    },
                    iconsCategory: function () {
                        return iconsCategory
                    },
                    selectedIcon: function () {
                        return {icon :provider.icon, icon_src: provider.icon_src};
                    }
                },
            }).result.then(function (icon) {
                var requestData = getFiltersValues();
                $scope.parentId && (requestData.parent_id = $scope.parentId);
                casinoProviderService.setIcon({provider: provider.name, icon: icon.name}).then(function (response) {
                        if (response.status === "ok") {
                            logger.logSuccess('global.successfullyUpdated');
                            provider.icon = icon.name;
                            provider.icon_src = icon.src;
                            updateList(requestData)
                        } else {
                            errorHandler(response.message);
                        }
                    },
                    function (response) {
                        errorHandler(response.message);
                    });
            });
        };

        $scope.getDateTime = function (dateString) {
            return new Date($filter("convertDateToUserTimezone")(dateString)).getTime()
        };


        
        $scope.getProviderFullName = function (key) {
            for (var i = 0, length = $scope.providers.length; i < length; i++) {
                if ($scope.providers[i].name === key) {
                    return $scope.providers[i].title;
                }
            }
        };

        $scope.$on("$destroy", function () {
            if ( settingsService.getFilters().parents ){
                while (settingsService.getFilters().parents.length) {
                    settingsService.getFilters().parents.shift();
                }
            }
            
            settingsService.getFilters().status = 'published';
        });

        $scope.ignoreColumns = {
            author: true,
            blocked_countries: true,
            created_at: true,
            'hasJustice': true,
            'justice':true,
            status: true,
            icon: true,
            "$$hashKey": true
        };
        if (userStorage.getUserData().permissions.indexOf('manageGameProviders') !== -1) {
            $scope.tools = {
                edit: {
                    action: function (item) {
                        $scope.editProvider(item);
                    },
                    title: function () {
                        return toolsMap[$scope.filterOptions.status].editToggle.title;
                    }
                },
                inactiveToggle: {
                    action: function (item) {
                        $scope.inactiveToggle(item, toolsMap[$scope.filterOptions.status].inactiveToggle.action, toolsMap[$scope.filterOptions.status].inactiveToggle.title)
                    },
                    class: function () {
                        return toolsMap[$scope.filterOptions.status].inactiveToggle.class;
                    },
                    title: function () {
                        return toolsMap[$scope.filterOptions.status].inactiveToggle.title;
                    }
                },
                addIcon: {
                    action: function (item) {
                        $scope.addIcon(item)
                    },
                    class: function () {
                        return "plus";
                    },
                    title: function () {
                        return "Add Icon";
                    }
                },
                publishToggle: {
                    action: function (item) {
                        $scope.deleteProviders(item)
                    },
                    class: function () {
                        return $scope.filterOptions.status;
                    },
                    title: function () {
                        return toolsMap[$scope.filterOptions.status].publishToggle.title;
                    }
                }
            };
        }


        $scope.onFilterSelect
            = $scope.onFilterDeselect
            = $scope.onFilterSelectAll
            = $scope.onFilterDeselectAll
            = function () {
            return $scope.pagination.changePage()
        };

        function getFiltersValues() {
            var providers = [];

            $scope.multiSelect.selectedProviders.forEach(function (value) {
                providers.push(providerTitleNameMap[value]);
            });

            currentFilters = {
                current_page: $scope.pagination.page,
                limit: $scope.pagination.limit,
                status: $scope.filterOptions.status,
                parents: providers,
                search: $scope.filterOptions.search
            };

            return currentFilters
        }

        function updateList (requestOptions) {
            settingsService.setFilters(requestOptions);
            casinoProviderService.getProviders(requestOptions).then(
                function (response) {
                    if (response.status === "ok") {
                        $scope.providers = angular.copy(response.providers);
                        $scope.pagination.totalItems = parseInt(response.total_count);
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.listFilterObject = {
            action: function () {
                var requestData =  getFiltersValues();
                $scope.parentId && (requestData.parent_id = $scope.parentId);
                updateList(requestData)
            }
        };

    }
]);